// This file can be replaced during build by using the `fileReplacements` array.
// `ng build` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  baseUrl: 'https://casco.mk/',
  firebaseConfig: {
    apiKey: "AIzaSyCv15akmrHuu61keSghZrxmHRyqWg-tquY",
    authDomain: "feather-menu-development.firebaseapp.com",
    projectId: "feather-menu-development",
    storageBucket: "feather-menu-development.firebasestorage.app",
    messagingSenderId: "251250130235",
    appId: "1:251250130235:web:88a39d444a11d23200cb1e",
    measurementId: "G-G5YS6FLDXN"
  },
  fcmUrl: 'https://fcm.googleapis.com/v1/projects/feather-menu-development/messages:send',
  getAccessTokenUrl: 'https://us-central1-feather-menu-development.cloudfunctions.net/getAccessToken',
  vapidKey: 'BFdJghqpmQ_PVoXrG99Uggzqs7oZs4oRYTjnhQvPmtPm2bwzXN2n6AiFBh8l9V-iHfVzL5KaSf4ZsjsUkpe5TdA',
  // Empty = UxCamService is a no-op, so localhost/dev sessions don't land in the production
  // recording app. Paste '2lmkyl9d5id5e2u-eu' here temporarily to verify the integration.
  uxcamAppKey: ''
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
